export const accountsNeedToFetchStatuses =
  "initial_pulling,connected,failed,deactivated,connected_for_billing,inactive,missing_sub_account_role";
